<script setup lang="ts">
import { Dialog, Drawer } from 'primevue'
import { onMounted } from 'vue'
import { useMobile } from '../hooks/useMobile'

const props = withDefaults(
  defineProps<{
    visible: boolean
    modal?: boolean
  }>(),
  {
    modal: true, // 设置 modal 的默认值为 true
  },
)

const emit = defineEmits<{
  'update:visible': [value: boolean]
}>()

const { isMobile } = useMobile()

onMounted(() => {})
</script>

<template>
  <Drawer
    v-if="isMobile"
    :modal="props.modal"
    :pt="{ root: '!max-h-[60vh] !h-auto overflow-scroll' }"
    :block-scroll="true"
    :visible="props.visible"
    position="bottom"
    :show-close-icon="false"
    @update:visible="emit('update:visible', $event)"
  >
    <template #container>
      <slot></slot>
    </template>
  </Drawer>
  <Dialog
    v-else
    :visible="props.visible"
    :modal="props.modal"
    :style="{ width: '460px', borderRadius: '20px', border: '2px solid #000', marginTop: '20vh' }"
    position="top"
    @update:visible="emit('update:visible', $event)"
  >
    <template #container>
      <slot></slot>
    </template>
  </Dialog>
</template>

<style>
:deep(.p-drawer) {
  height: 60vh;
  overflow: scroll;
}
</style>
